export const errorMessageMap = new Map([
  ['no data.', '您無此頁面的閱覽權限，或是此頁面已經被刪除'],
  ['invalid scopes', '您無此權限'],
  ['invalid factory scopes', '您無此單位內相關權限，請聯絡系統管理員'],
  ['invalid organization scopes', '您無此單位內相關權限，請聯絡系統管理員'],
  ['no scopes', '無權限'],
  ['Too Many Attempts.', '請求次數過多，請稍候再試'],
  ['has related data.', '正在被使用中，無法刪除。'],
  ['File not found.', '無法找到此檔案。'],
  ['common error', '發生錯誤，請稍候再試'],
  ['delete error.', '發生錯誤，請稍候再試'],
]);
